import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { ContentProvider, SelectionProvider } from './context';
import { client } from './graphql';
import { AppRoutes } from './routes';

const App = () => {
    return (
        <ApolloProvider client={client}>
            <BrowserRouter>
                <ContentProvider>
                    <SelectionProvider>
                        <AppRoutes />
                    </SelectionProvider>
                </ContentProvider>
            </BrowserRouter>
        </ApolloProvider>
    );
};

export default App;
